export default __webpack_public_path__ + "static/FTRegolaNeue-Heavy-25ca5e4ac2d6e640427cefaa80e4a9b4.woff2";